<div class="flex flex-col gap-y-2 w-full">
  <form
  [formGroup]="filtersForm"
  class=""
  [ngClass]="!allInDropdown ? 'w-full justify-between' : 'justify-start'"
>
  <div class="flex flex-col">
    <div
      class="w-full flex justify-between items-start gap-4 flex-wrap"
    >
      <div
        class="flex flex-wrap justify-start items-center gap-3 filters-container"
      >
        <ng-container *ngFor="let filter of filtersList">
          <p-multiSelect
            *ngIf="filter.type === 'multiselect'"
            [options]="filter.multiSelectItems"
            [formControlName]="filter.key"
            [group]="filter.group ?? false"
            [optionLabel]="filter.relation_column"
            [optionValue]="filter.relation_filter_column"
            [maxSelectedLabels]="maxSelectedDropdowns"
            variant="filled"
            display="chip"
            [placeholder]="filter.placeholder"
            [styleClass]="'select-filter'"
          >
          </p-multiSelect>

          <p-calendar
            *ngIf="filter.type == 'date-between'"
            [formControlName]="filter.key"
            [showIcon]="true"
            [showOnFocus]="false"
            selectionMode="range"
            dateFormat="dd/mm/yy"
            inputId="buttondisplay"
          />
        </ng-container>

        <div class="flex justify-end gap-2">
          <button
            *ngIf="showApplyDeleteButton"
            (click)="search()"
            class="rounded-full bg-primary py-2 px-4 text-xs text-white"
          >
            Aplicar
          </button>
          <button
            *ngIf="showApplyDeleteButton"
            (click)="clearFilters()"
            class="rounded-full bg-red-400 hover:bg-red-500 py-2 px-4 text-xs text-white"
          >
            Borrar
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
  <div
    class="flex flex-row flex-wrap lg:justify-between items-start gap-y-4 w-full"
  >
    <form
      [formGroup]="filtersForm"
      class="flex gap-x-4 mr-2 items-start"
      [ngClass]="!allInDropdown ? 'w-full justify-between' : 'justify-start'"
    >
      <input
        *ngIf="filtersForm && hasSearch()"
        class="text-xs max-w-56 !p-1.5 rounded-xl !bg-bg2 !border-2 !border-lightGray2 !text-darkGray !focus:ring-none !focus:shadow animate-fade-in-right"
        [formControlName]="searchItem().key"
        [placeholder]="searchItem().placeholder"
        type="text"
        (keydown.enter)="search(); $event.preventDefault()"
        (keydown.enter)="onSearchChanged(getInputValue($event)); $event.preventDefault()"
        (input)="onSearchChanged(getInputValue($event))"
      />
    </form>

    <div
      class="flex flex-wrap items-center xs:justify-end gap-1"
      *ngIf="showColumnsAndPerPage"
    >
      <div class="flex justify-end items-center gap-2">
        <button
          *ngFor="let action of bulkActions"
          (click)="bulkActionClick.emit(action.key)"
          class="text-white text-xs py-2 rounded-full hover:bg-opacity-90 hover:shadow-md duration-300 px-3"
          [class.bg-green]="action.key == 'export'"
          [class.bg-primary]="action.key != 'export'"
        >
          {{ action.label }}
        </button>
      </div>
      <button
        (click)="opColumns.toggle($event)"
        class="border border-lightGray2 p-2 rounded-xl hover:bg-lightGray2 text-darkGray flex justify-center items-center gap-2 text-xs"
      >
        Columnas
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="w-3"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M6 9l6 6l6 -6" />
        </svg>
      </button>
      <p-overlayPanel #opColumns>
        <div
          class="p-2"
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="column-select-menu"
        >
          <div *ngFor="let header of tableHeaders">
            <label
              class="inline-flex items-center px-2 py-1 disabled:opacity-50 disabled:cursor-wait"
            >
              <input
                [(ngModel)]="header.active"
                (ngModelChange)="onChangeColumn.emit(tableHeaders)"
                class="text-primary transition duration-150 ease-in-out border-gray-300 rounded shadow-sm focus:border-primary focus:ring focus:ring-primary focus:ring-opacity-50"
                type="checkbox"
              />
              <span class="ml-2 text-darkGray text-xs">{{ header.name }}</span>
            </label>
          </div>
        </div>
      </p-overlayPanel>
      <select
        [(ngModel)]="perPage"
        (change)="onChangePerPage.emit(perPage)"
        class="border border-lightGray2 pr-8 py-2 rounded-xl hover:bg-lightGray2 text-darkGray flex justify-center items-center gap-2 text-xs"
      >
        <option *ngFor="let option of perPageOptions" [value]="option">
          {{ option }}
        </option>
      </select>
    </div>
  </div>
</div>
